import {useEffect, useState} from "react";
import backgroundImage from "../../../resources/background.png";
import Aos from "aos";
import {useNavigate} from "react-router-dom";
import {MaximumWordLength} from "../../../utils/MaximumWordLength";

const PortfolioCard = ({id, title, description, tags, imageBackground, index = 0}) => {
    const navigate = useNavigate();

    const badgeColors = [
        'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
        'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300', 
        'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
    ];

    const selectedBadgeStyle = badgeColors[index % badgeColors.length];

    const handleClick = () => {
        window.scrollTo(0, 0);
        navigate("/portfolio/" + id)
    };
    
    return(
        <div className="group relative bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
            {/* Image section with consistent sizing */}
            <div className="relative overflow-hidden rounded-t-2xl">
                <img 
                    className="w-full h-48 object-cover transition-transform duration-700 group-hover:scale-110" 
                    src={imageBackground} 
                    alt={title}
                />
                
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* View button overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                    <button 
                        onClick={handleClick}
                        className="px-6 py-3 bg-white text-slate-900 dark:bg-slate-900 dark:text-white font-semibold rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                    >
                        <span className="flex items-center gap-2">
                            View Project
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                        </span>
                    </button>
                </div>

                {/* Decorative accent line */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-slate-900 dark:bg-slate-400"></div>
            </div>
            
            {/* Content section */}
            <div className="p-6 space-y-4">
                {/* Title */}
                <h3 className="text-xl font-bold text-slate-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300 leading-tight">
                    {MaximumWordLength(title, 25)}
                </h3>
                
                {/* Description */}
                <p className="text-slate-600 dark:text-slate-400 leading-relaxed font-light transition-colors duration-300">
                    {MaximumWordLength(description, 80)}
                </p>
                
                {/* Tags */}
                <div className="flex flex-wrap gap-2 pt-2">
                    {tags?.slice(0, 4).map((tag, tagIndex) => (
                        <span 
                            key={tagIndex}
                            className={`inline-flex items-center px-3 py-1 text-xs font-medium rounded-full ${selectedBadgeStyle}`}
                        >
                            {tag.name || tag}
                        </span>
                    ))}
                    {tags?.length > 4 && (
                        <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300 rounded-full">
                            +{tags.length - 4} more
                        </span>
                    )}
                </div>
            </div>

            {/* Hover effect overlay removed for minimalism */}
        </div>
    )
}
export default PortfolioCard;